var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":"small","disabled":_vm.disabled,"loading":_vm.loading},domProps:{"textContent":_vm._s(_vm.label)},on:{"click":function($event){$event.stopPropagation();return _vm.dispatchClickEvent.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }